import {Injectable} from "@angular/core";
import {ActivatedRouteSnapshot, Resolve, RouterStateSnapshot} from "@angular/router";
import {SitesService} from "../sites/sites.service";
import {Observable} from "rxjs";
import {Site} from "../users/users.types";
import {InterfacesService} from "./interfaces.service";
import {DcsConfig} from "./interfaces.types";

@Injectable({
    providedIn: 'root'
})
export class InterfacesResolvers implements Resolve<any>
{
    /**
     * Constructor
     */
    constructor(private _interfacesService: InterfacesService)
    {
    }

    // -----------------------------------------------------------------------------------------------------
    // @ Public methods
    // -----------------------------------------------------------------------------------------------------

    /**
     * Resolver
     *
     * @param route
     * @param state
     */
    resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<DcsConfig[]>
    {
        return this._interfacesService.getDcsConfig();
    }
}
